import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import { JOURNEY } from '../../data/content';

const Journey = () => (
  <section className="bg-white py-24 md:py-32" data-testid="journey-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          index="01"
          overline="The Journey"
          title="Your Career Journey Starts Here"
          description="One clear path from confusion to career growth — discover, decide, develop, grow."
        />
        <Reveal delay={0.2}>
          <Link
            to="/career-roadmaps"
            data-testid="journey-start-cta"
            className="group inline-flex items-center gap-2 text-sm font-bold text-coral transition-colors hover:text-coral-deep"
          >
            Start Your Career Journey
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>

      <div className="relative mt-16 grid gap-6 md:grid-cols-4 md:gap-8">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="absolute left-0 right-0 top-8 hidden h-px origin-left bg-gradient-to-r from-coral via-navy/20 to-navy/10 md:block"
        />
        {JOURNEY.map((item, i) => (
          <Reveal key={item.step} delay={0.12 * i}>
            <div className="group relative rounded-3xl border border-line bg-white p-8 shadow-card transition-[box-shadow,transform] duration-300 hover:-translate-y-1.5 hover:shadow-card-hover" data-testid={`journey-step-${item.step}`}>
              <span className="relative z-10 flex h-16 w-16 items-center justify-center rounded-2xl bg-navy font-display text-xl font-bold text-white transition-colors duration-300 group-hover:bg-coral">
                {item.step}
              </span>
              <h3 className="mt-6 font-display text-xl font-semibold text-navy md:text-2xl">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Journey;
